(function setScrollbarWidth() {
  let rafId = null;

  function updateScrollbarWidth() {
    const width = window.innerWidth - document.documentElement.clientWidth;
    document.documentElement.style.setProperty('--scrollbar-width', width + 'px');
  }

  function scheduleUpdateScrollbarWidth() {
    if (rafId) return;

    rafId = requestAnimationFrame(() => {
      rafId = null;
      updateScrollbarWidth();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateScrollbarWidth);
  } else {
    updateScrollbarWidth();
  }
  window.addEventListener('resize', scheduleUpdateScrollbarWidth, { passive: true });
})();

(function handleFiboCheckoutReturnCartReset() {
  const markerKey = 'fibo_storefront_checkout_started';
  const markerMaxAgeMs = 2 * 60 * 60 * 1000;
  const inDesignMode = Boolean(window.Shopify && window.Shopify.designMode);

  if (inDesignMode) return;

  let marker = null;
  try {
    const raw = sessionStorage.getItem(markerKey);
    if (!raw) return;
    marker = JSON.parse(raw);
  } catch (_parseError) {
    marker = null;
  }

  if (!marker || !marker.ts) {
    try {
      sessionStorage.removeItem(markerKey);
    } catch (_removeError) {}
    return;
  }

  if (Date.now() - Number(marker.ts) > markerMaxAgeMs) {
    try {
      sessionStorage.removeItem(markerKey);
    } catch (_removeError) {}
    return;
  }

  fetch(`${window.Shopify?.routes?.root || '/'}cart/clear.js`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'same-origin'
  })
    .then(() => {
      document.dispatchEvent(new CustomEvent('cart:refresh'));
    })
    .catch(() => {
      /* keep checkout return resilient even if clear fails */
    })
    .finally(() => {
      try {
        sessionStorage.removeItem(markerKey);
      } catch (_removeError) {}
    });
})();

document.addEventListener("click", (event) => {
  const summary = event.target.closest("accordion-disclosure summary");
  if (!summary) return;

  const accordion = summary.closest("accordion-disclosure");
  const group = accordion.closest(".accordion-group");
  if (!group) return;

  requestAnimationFrame(() => {
    if (!accordion.classList.contains("is-open")) return;

    const openAccordions = group.querySelectorAll(
      "accordion-disclosure.is-open"
    );

    openAccordions.forEach((item) => {
      if (item === accordion) return;

      const details = item.querySelector("details");

      item.classList.remove("is-open");

      if (details) {
        details.open = false;
        details.style.height = null;
        details.style.overflow = null;
      }
    });
  });
});

let variantPickerCustomLoadPromise = null;

function loadVariantPickerCustom() {
  const moduleUrl = window.__smilodoxVariantPickerCustomUrl;

  if (!moduleUrl) {
    return Promise.resolve(null);
  }

  if (customElements.get('variant-picker-custom')) {
    return Promise.resolve(true);
  }

  if (!variantPickerCustomLoadPromise) {
    variantPickerCustomLoadPromise = import(moduleUrl)
      .then(() => true)
      .catch((error) => {
        variantPickerCustomLoadPromise = null;
        throw error;
      });
  }

  return variantPickerCustomLoadPromise;
}

function requestVariantPickerCustom() {
  loadVariantPickerCustom().catch((error) => {
    console.error('Variant picker runtime failed to load:', error);
  });
}

document.addEventListener('click', (event) => {
  if (!(event.target instanceof Element)) return;

  if (
    event.target.closest('.cross-sell-card__button') ||
    event.target.closest('.cross-sell-product__button') ||
    event.target.closest('variant-picker-custom')
  ) {
    requestVariantPickerCustom();
  }
}, { passive: true });

document.addEventListener('click', (event) => {
  if (event.target instanceof Element && event.target.closest('[aria-controls="cart-drawer"]')) {
    if (document.querySelector('variant-picker-custom')) {
      requestVariantPickerCustom();
    }
  }
}, { passive: true });

function initializeVariantPickerCustomForCartCrossSell() {
  if (document.querySelector('variant-picker-custom')) {
    requestVariantPickerCustom();
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeVariantPickerCustomForCartCrossSell, { once: true });
      } else {
  initializeVariantPickerCustomForCartCrossSell();
}


let freeShippingGiftLoadPromise = null;

function loadFreeShippingGift() {
  const config = window.freeShippingGiftConfig;

  if (!config?.moduleUrl) {
    return Promise.resolve(null);
  }

  if (window.__freeShippingGiftInstance) {
    return Promise.resolve(window.__freeShippingGiftInstance);
  }

  if (!freeShippingGiftLoadPromise) {
    freeShippingGiftLoadPromise = import(config.moduleUrl)
      .then(({ default: FreeShippingGift }) => {
        window.__freeShippingGiftInstance ||= new FreeShippingGift();
        return window.__freeShippingGiftInstance;
      })
      .catch((error) => {
        freeShippingGiftLoadPromise = null;
        throw error;
      });
  }

  return freeShippingGiftLoadPromise;
}

function requestFreeShippingGift() {
  loadFreeShippingGift().catch((error) => {
    console.error('Free gift runtime failed to load:', error);
  });
}

document.addEventListener('click', (event) => {
  if (event.target instanceof Element && event.target.closest('[aria-controls="cart-drawer"]')) {
    requestFreeShippingGift();
  }
    }, { passive: true });

document.addEventListener('dialog:after-show', (event) => {
  if (event.target instanceof Element && event.target.matches('#cart-drawer, cart-drawer')) {
    requestFreeShippingGift();
  }
}, true);

document.addEventListener('cart:change', requestFreeShippingGift);
document.addEventListener('cart:refresh', requestFreeShippingGift);

function initializeFreeShippingGiftForExistingCart() {
  if (Number(window.freeShippingGiftConfig?.cartItemCount || 0) > 0) {
    requestFreeShippingGift();
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeFreeShippingGiftForExistingCart, { once: true });
    } else {
  initializeFreeShippingGiftForExistingCart();
}


(function initCheckoutWarningPopup() {
  const checkoutUrl = () => (window.Shopify?.routes?.root || '/') + 'checkout';
  const PROCEED_GUARD_MS = 450;

  const goToCheckout = () => {
    if (!window.Shopify?.designMode) window.location.href = checkoutUrl();
  };

  const openPopup = (popup) => {
    popup.classList.remove('checkout-warning-popup--hidden');
    popup.setAttribute('aria-hidden', 'false');
    popup.dataset.openedAt = String(Date.now());
  };

  const hidePopup = (popup) => {
    popup.classList.add('checkout-warning-popup--hidden');
    popup.setAttribute('aria-hidden', 'true');
    delete popup.dataset.openedAt;
  };

  const isGiftLine = (item) => {
    const properties = item?.properties || {};
    return Boolean(properties['_free-gift-tier'] || properties['_is_free_gift'] === 'true');
  };

  const isGiftCardLine = (item) => Boolean(item?.gift_card || item?.product_type === 'Gift Cards');

  const parseMoneyCents = (value) => {
    if (value === null || value === undefined) return 0;

    if (typeof value === 'number') {
      if (!Number.isFinite(value)) return 0;
      return Number.isInteger(value) ? value : Math.round(value * 100);
    }

    if (typeof value === 'string') {
      const trimmed = value.trim();
      if (trimmed === '') return 0;

      const normalized = trimmed.replace(/\s+/g, '').replace(',', '.');
      const parsed = Number(normalized);
      if (!Number.isFinite(parsed)) return 0;

      return /[.,]/.test(trimmed) ? Math.round(parsed * 100) : Math.round(parsed);
    }

    if (typeof value === 'object') {
      if (value.amount !== undefined) return parseMoneyCents(value.amount);
      if (value.total_allocated_amount !== undefined) return parseMoneyCents(value.total_allocated_amount);
    }

    return 0;
  };

  const getCartLevelDiscountCents = (cart) => {
    const applications = Array.isArray(cart?.cart_level_discount_applications)
      ? cart.cart_level_discount_applications
      : [];

    const fromApplications = applications.reduce((total, application) => (
      total + parseMoneyCents(application?.total_allocated_amount)
    ), 0);

    const itemsSubtotalCents = parseMoneyCents(cart?.items_subtotal_price);
    const totalPriceCents = parseMoneyCents(cart?.total_price);
    const fromTotals = Math.max(0, itemsSubtotalCents - totalPriceCents);

    return Math.max(0, fromApplications, fromTotals);
  };

  const calculatePaidSubtotalCents = (cart) => {
    const items = Array.isArray(cart?.items) ? cart.items : [];

    const paidAfterLineDiscounts = items.reduce((total, item) => {
      if (isGiftLine(item) || isGiftCardLine(item)) return total;
      return total + parseMoneyCents(item?.final_line_price);
    }, 0);

    const cartLevelDiscountCents = Math.min(
      paidAfterLineDiscounts,
      getCartLevelDiscountCents(cart)
    );

    return Math.max(0, paidAfterLineDiscounts - cartLevelDiscountCents);
  };

  async function handleCheckoutClick(e) {
    const target = e.target;
    if (!(target instanceof Element)) return;

    const checkoutBtn = target.closest('[data-checkout-trigger], button.cart__checkout-button');
    if (!checkoutBtn) return;

    const cartDrawer = checkoutBtn.closest('#cart-drawer') || checkoutBtn.closest('cart-drawer');
    if (!cartDrawer) return;

    const popup = cartDrawer.querySelector('.checkout-warning-popup');

    if (!popup) {
      return goToCheckout();
    }

    e.preventDefault();
    e.stopPropagation();
    if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();

    try {
      await loadFreeShippingGift();
    } catch (error) {
      console.error('Free gift runtime unavailable at checkout:', error);
      return goToCheckout();
    }

    const runtimeConfig = window.__freeGiftRuntimeConfig;

    if (!runtimeConfig?.freeGift?.enabled) {
      return goToCheckout();
    }

    fetch(`${window.Shopify?.routes?.root || '/'}cart.js`)
      .then((r) => r.json())
      .then((cart) => {
        const items = Array.isArray(cart?.items) ? cart.items : [];
        const paidSubtotalCents = calculatePaidSubtotalCents(cart);

        const eligibleTiers = (runtimeConfig.freeGift.tiers || [])
          .filter((tier) => paidSubtotalCents >= Number(tier.thresholdCents || 0))
          .map((tier) => String(tier.tier));

        if (eligibleTiers.length === 0) {
          goToCheckout();
          return;
        }

        const giftLinesByTier = {};
        items.forEach((item) => {
          if (!isGiftLine(item)) return;
          const properties = item?.properties || {};
          const tier = String(properties['_free-gift-tier'] || '');
          if (!giftLinesByTier[tier]) giftLinesByTier[tier] = 0;
          giftLinesByTier[tier] += 1;
        });

        const hasMissingTierGift = eligibleTiers.some((tier) => !giftLinesByTier[tier]);

        if (hasMissingTierGift) {
          openPopup(popup);
          return;
        }

        goToCheckout();
      })
      .catch(() => {
        goToCheckout();
      });
  }

  document.addEventListener('click', handleCheckoutClick, true);

  document.addEventListener('click', (e) => {
    const target = e.target;
    if (!(target instanceof Element)) return;

    const cartDrawer = target.closest('#cart-drawer')
      || target.closest('cart-drawer')
      || document.querySelector('#cart-drawer')
      || document.querySelector('cart-drawer');

    if (!cartDrawer) return;

    const popup = cartDrawer.querySelector('.checkout-warning-popup');
    if (!popup) return;

    const popupOpen = !popup.classList.contains('checkout-warning-popup--hidden');
    const clickedInsideContent = Boolean(target.closest('.checkout-warning-content'));

    const closeBtn = target.closest('.close-warning-popup');
    if (closeBtn) {
      e.preventDefault();
      e.stopPropagation();
      if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
      hidePopup(popup);
      return;
    }

    const proceedBtn = target.closest('.proceed-without-gift');
    if (proceedBtn) {
      e.preventDefault();
      e.stopPropagation();
      if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();

      const openedAt = Number(popup.dataset.openedAt || 0);
      if (openedAt && (Date.now() - openedAt) < PROCEED_GUARD_MS) {
        return;
      }

      hidePopup(popup);
      goToCheckout();
      return;
    }

    if (popupOpen && !clickedInsideContent) {
      e.preventDefault();
      e.stopPropagation();
      if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
      hidePopup(popup);
    }
  });

  document.addEventListener('cart:refresh', () => {
    const popup = document.querySelector('#cart-drawer .checkout-warning-popup, cart-drawer .checkout-warning-popup');
    if (popup) hidePopup(popup);
  });
})();
document.addEventListener('click', function (e) {
  const changeBtn = e.target.closest('.cart-discount__change-code');
  if (changeBtn) {
    e.preventDefault();
    e.stopPropagation();

    const cartDiscount = changeBtn.closest('.cart-discount');
    if (!cartDiscount) return;

    cartDiscount.classList.add('expand');

    const input = cartDiscount.querySelector('.cart-discount-field input[type="text"]');
    if (input) {
      requestAnimationFrame(() => input.focus());
    }
    return;
  }

  const header = e.target.closest('.cart-discount__header');
  if (!header) return;
  if (e.target.closest('.cart-discount__active-codes')) return;
  const cartDiscount = header.closest('.cart-discount');
  if (cartDiscount) {
    cartDiscount.classList.toggle('expand');
  }
});



function updateCrossSell(contextEl, variant) {
  const productContainer = contextEl.closest('.cross-sell-popup__body');
  if (productContainer) {
    if (variant.featured_image && typeof window.updateResponsiveImage === 'function') {
      const mainImage = productContainer.querySelector('.cross-sell-product__image img');
      window.updateResponsiveImage(mainImage, variant);
    }
    const addBtn = productContainer.querySelector('.cross-sell-product__button');
    if (!addBtn) return;

    addBtn.classList.toggle('is-disabled', !variant.available);
  }
}

window.updateCrossSell = updateCrossSell;

document.addEventListener('click', function (e) {
  const openBtn = e.target.closest('.cross-sell-card__button');
  const closeBtn = e.target.closest('.cross-sell-popup__close');

  const cartDrawer = document.querySelector('#cart-drawer');
  const popups = document.querySelectorAll('.cross-sell-popup');

  if (openBtn) {
    const productValue = openBtn.getAttribute('data-product');
    if (!productValue || !cartDrawer) return;

    popups.forEach(popup => {
      popup.classList.remove('open');
    });

    const targetPopup = document.querySelector(
      `.cross-sell-popup[data-product="${productValue}"]`
    );

    if (!targetPopup) return;

    if (targetPopup.parentElement !== cartDrawer) {
      cartDrawer.appendChild(targetPopup);
    }

    const popupImage = targetPopup.querySelector('.cross-sell-product__image img');
    if (popupImage) {
      popupImage.loading = 'eager';
      popupImage.fetchPriority = 'high';
    }

    requestAnimationFrame(() => {
      targetPopup.classList.add('open');
    });
    return;
  }

  if (closeBtn) {
    popups.forEach(popup => popup.classList.remove('open'));
  }
});


document.addEventListener('click', async function (e) {
  const addBtn = e.target.closest('.cross-sell-product__button');
  if (!addBtn) return;
  if (addBtn.getAttribute('aria-busy') === 'true') return;

  const popup = addBtn.closest('.cross-sell-popup');
  if (!popup) return;

  addBtn.setAttribute('aria-busy', 'true');
  addBtn.disabled = true;

  try {
    try {
      await loadVariantPickerCustom();
    } catch (error) {
      console.error('Variant picker runtime unavailable for cross-sell add:', error);
      return;
    }

  const variantPicker = popup.querySelector('variant-picker-custom');
  if (!variantPicker) return;

  const variantId = variantPicker.getAttribute('data-selected-variant-id');
  if (!variantId) return;

    await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        id: variantId,
        quantity: 1
      })
    });

    popup.classList.remove('open');

    document.dispatchEvent(new CustomEvent('cart:refresh'));
  } catch (error) {
    console.error('Cross-sell add to cart failed', error);
  } finally {
    addBtn.removeAttribute('aria-busy');
    addBtn.disabled = false;
  }
});


class CartFeaturedCollection extends HTMLElement {
  constructor() {
    super();
    this.sliders = {};
    this.activeId = null;
    this.__initialized = false;
  }

  connectedCallback() {
    if (this.__initialized) return;
    this.__initialized = true;

    this.tabs = this.querySelectorAll('[data-tab]');
    this.contents = this.querySelectorAll('[data-content]');
    this.viewAll = this.querySelector('[data-view-all-link]');
    this.prevBtn = this.querySelector('[data-prev]');
    this.nextBtn = this.querySelector('[data-next]');

    this.bindEvents();

    const initialTab =
      this.querySelector('[data-tab].active') || this.tabs[0];

    if (initialTab) {
      requestAnimationFrame(() => {
        this.activate(initialTab);
      });
    }
  }

  bindEvents() {
    this.tabs.forEach(tab => {
      tab.addEventListener('click', () => this.activate(tab));
    });


    this.prevBtn?.addEventListener('click', () => {
      const slider = this.currentSlider();
      if (slider) slider.slidePrev();
    });

    this.nextBtn?.addEventListener('click', () => {
      const slider = this.currentSlider();
      if (slider) slider.slideNext();
    });
  }

  activate(tab) {
    const id = tab.dataset.tab;
    if (!id) return;

    this.activeId = id;

    this.tabs.forEach(t =>
      t.classList.toggle('active', t === tab)
    );

    this.contents.forEach(c =>
      c.classList.toggle('active', c.dataset.content === id)
    );

    this.initSlider(id);


    requestAnimationFrame(() => {
      const slider = this.currentSlider();
      if (!slider) return;

      slider.update();
      slider.updateSlides();
      slider.updateProgress();
    });
  }

  initSlider(id) {
    if (this.sliders[id]) return;

    const el = this.querySelector(`[data-slider="${id}"]`);
    if (!el) return;

    const initializeSlider = () => {
      if (this.sliders[id]) return;
      if (typeof window.Swiper === 'undefined') {
        if (window.RO && typeof window.RO.loadSwiper === 'function') {
          window.RO.loadSwiper().catch(() => {});
        }

        if (!el.__swiperReadyBound) {
          el.__swiperReadyBound = true;
          window.addEventListener('swiper:ready', initializeSlider, { once: true });
        }
        return;
      }

      const hasSwatchCards = !!el.querySelector('.product-card__swatch-list [type="radio"]');

      this.sliders[id] = new window.Swiper(el, {
        loop: !hasSwatchCards,
        loopAdditionalSlides: 2,
        speed: 450,
        slidesPerView: 1.2,
        spaceBetween: 4,
        watchOverflow: true,
        resistanceRatio: 0.6,
        touchRatio: 1,
        breakpoints: {
          0: {
            slidesPerView: 1.7
          },
          768: {
            slidesPerView: 2.7
          }
        }
      });

      requestAnimationFrame(() => {
        this.sliders[id].update();
      });
    };

    if (el.offsetParent !== null) {
      initializeSlider();
      return;
    }

    if (!('IntersectionObserver' in window)) {
      requestAnimationFrame(initializeSlider);
      return;
    }

    const observer = new IntersectionObserver((entries, io) => {
      const isVisible = entries.some((entry) => entry.isIntersecting);
      if (!isVisible) return;

      io.disconnect();
      initializeSlider();
    }, {
      root: null,
      rootMargin: '400px 0px',
      threshold: 0.01
    });

    observer.observe(el);
  }

  currentSlider() {
    return this.sliders[this.activeId] || null;
  }

  disconnectedCallback() {
    Object.values(this.sliders).forEach(slider => {
      if (slider && slider.destroy) {
        slider.destroy(true, true);
      }
    });

    this.sliders = {};
    this.activeId = null;
    this.__initialized = false;
  }
}

if (!customElements.get('cart-featured-collection')) {
  customElements.define(
    'cart-featured-collection',
    CartFeaturedCollection
  );
}
/* Cart drawer end */


(function () {
  if (customElements.get('countdown-timer-custom')) return;
  function parseEUDate(dateString) {
    if (!dateString) return null;

    const parts = dateString.trim().split(' ');
    const dateParts = parts[0].split('/');
    const timeParts = (parts[1] || '00:00:00').split(':');

    if (dateParts.length !== 3) return null;

    let day = parseInt(dateParts[0], 10);
    let month = parseInt(dateParts[1], 10);
    const year = parseInt(dateParts[2], 10);

    // Theme editor uses DD/MM/YYYY; mis-typed US MM/DD/YYYY breaks when "month" > 12.
    if (month > 12 && day <= 12) {
      const usMonth = day;
      const usDay = month;
      day = usDay;
      month = usMonth;
    }

    const hour = parseInt(timeParts[0], 10) || 0;
    const minute = parseInt(timeParts[1], 10) || 0;
    const second = parseInt(timeParts[2], 10) || 0;

    return new Date(year, month - 1, day, hour, minute, second);
  }

  function parseEndDate(dateString) {
    if (!dateString) return null;

    const trimmed = dateString.trim();

    if (/^\d{4}-\d{2}-\d{2}T/.test(trimmed)) {
      const isoDate = new Date(trimmed);
      if (!isNaN(isoDate.getTime())) return isoDate;
    }

    const euDate = parseEUDate(trimmed);
    if (euDate && !isNaN(euDate.getTime())) return euDate;

    const fallbackDate = new Date(trimmed);
    if (!isNaN(fallbackDate.getTime())) return fallbackDate;

    return null;
  }

  class CountdownTimerCustom extends HTMLElement {
    _hideCountdownBar() {
      const bar = this.closest('.countdown-timer, .sale-hero-countdown');
      if (bar) bar.hidden = true;
    }

    connectedCallback() {
      const endDate = this.getAttribute('data-end-date');

      const targetDate = parseEndDate(endDate);

      if (!targetDate || isNaN(targetDate.getTime())) {
        this._hideCountdownBar();
        return;
      }

      this.targetTime = targetDate.getTime();

      if (this.targetTime <= Date.now()) {
        this._hideCountdownBar();
        return;
      }

      this.labels = (this.getAttribute('data-labels') || 'T,S,M,S').split(',').map((l) => l.trim());
      this.dayLabelSingular = this.getAttribute('data-day-label-singular') || this.labels[0] || '';
      this.dayLabelPlural = this.getAttribute('data-day-label-plural') || this.dayLabelSingular;

      this._render();
      this._update();
      this.interval = setInterval(() => this._update(), 1000);
    }

    disconnectedCallback() {
      clearInterval(this.interval);
    }

    _render() {
      this.valueNodes = [];
      this.labelNodes = [];
      this.innerHTML = '';

      for (let i = 0; i < 4; i++) {
        const item = document.createElement('span');
        item.className = 'countdown-item';

        const valueNode = document.createTextNode('00 ');
        const labelNode = document.createElement('span');
        labelNode.textContent = this.labels[i] || '';

        item.appendChild(valueNode);
        item.appendChild(labelNode);
        this.appendChild(item);

        this.valueNodes.push(valueNode);
        this.labelNodes.push(labelNode);
      }
    }

    _update() {
      const diff = this.targetTime - Date.now();

      if (diff <= 0) {
        clearInterval(this.interval);
        this._hideCountdownBar();
        return;
      }

      const totalSeconds = Math.floor(diff / 1000);

      const days = Math.floor(totalSeconds / 86400);
      const hours = Math.floor((totalSeconds % 86400) / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;

      this.valueNodes[0].nodeValue = String(days).padStart(2, '0') + ' ';
      this.valueNodes[1].nodeValue = String(hours).padStart(2, '0') + ' ';
      this.valueNodes[2].nodeValue = String(minutes).padStart(2, '0') + ' ';
      this.valueNodes[3].nodeValue = String(seconds).padStart(2, '0') + ' ';

      if (this.labelNodes[0]) {
        this.labelNodes[0].textContent = days === 1 ? this.dayLabelSingular : this.dayLabelPlural;
      }
    }
  }

  customElements.define('countdown-timer-custom', CountdownTimerCustom);
})();

/* Auto apply discount code */

function getDiscountCookie(name) {
  const match = document.cookie
    .split('; ')
    .find(row => row.trim().startsWith(name + '='));
  if (!match) return undefined;
  const value = match.split('=').slice(1).join('=').trim();
  try {
    return decodeURIComponent(value);
  } catch {
    return value;
  }
}

function setDiscountCookie(name, value, days) {
  const date = new Date();
  date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
  const encoded = encodeURIComponent(value);
  document.cookie = `${name}=${encoded}; expires=${date.toUTCString()}; path=/; SameSite=Lax`;
}

function hasActiveSecretSaleSession() {
  try {
    const campaignKey =
      (window.SmilodoxSecretSaleConfig && window.SmilodoxSecretSaleConfig.campaignKey) ||
      'secret-sale-2026-10';
    const prefix = 'smilodox:secret-sale:';
    const expiry = parseInt(localStorage.getItem(`${prefix}expires-at:${campaignKey}`) || '0', 10);
    const raw = localStorage.getItem(`${prefix}session:${campaignKey}`);
    if (!raw || !expiry || expiry <= Date.now()) return false;
    const session = JSON.parse(raw);
    return Boolean(session && String(session.code || '').trim());
  } catch {
    return false;
  }
}

function applyAutoDiscount() {
  const shopSettings = window.SHOP_SETTINGS || {};
  const { autoDiscountEnabled, autoDiscountCode } = shopSettings;

  if (!autoDiscountEnabled || !autoDiscountCode) {
    return Promise.resolve(false);
  }

  // A validated Secret Sale session owns its campaign code. The general
  // promotion must not race or replace that attribution after ATC.
  if (hasActiveSecretSaleSession()) {
    return Promise.resolve(false);
  }

  const existingCode = getDiscountCookie('discount_code');
  if (existingCode) {
    return Promise.resolve(false);
  }

  return applyDiscountCode(autoDiscountCode);
}

function applyDiscountCode(discountCode) {
  if (!discountCode || typeof discountCode !== 'string') {
    return Promise.resolve(false);
  }
  return fetch(`${window.Shopify?.routes?.root || '/'}cart.js`)
    .then(response => {
      if (!response.ok) throw new Error('Failed to fetch cart');
      return response.json();
    })
    .then(cart => {
      if (!cart.items || cart.items.length === 0) {
        return false;
      }

      // Respect campaign / Secret Sale attribution already attached to the cart.
      // This keeps the web behavior aligned with autoDiscount.applyIfNoCode and
      // prevents the general code from replacing an influencer-specific code.
      if (Array.isArray(cart.discount_codes) && cart.discount_codes.length > 0) {
        return false;
      }

      return fetch(`${window.Shopify?.routes?.root || '/'}cart/update.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ discount: discountCode })
      })
        .then(response => {
          if (!response.ok) {
            if (response.status === 422) {
              throw new Error('invalid_discount');
            }
            throw new Error('Failed to apply discount');
          }
          return response.json();
        })
        .then(updatedCart => {
          const discountApplied =
            updatedCart.discount_codes?.length > 0 ||
            updatedCart.cart_level_discount_applications?.length > 0;
          if (discountApplied) {
            setDiscountCookie('discount_code', discountCode, 1);
            setDiscountCookie('discount_code_viewed', discountCode, 1);
            setDiscountCookie('discount_code_valid', discountCode, 1);

            document.dispatchEvent(new CustomEvent('cart:refresh'));

            return true;
          }

          return false;
        });
    })
    .catch(error => {
      console.error('Error applying discount:', error);
      return false;
    });
}



document.addEventListener('DOMContentLoaded', () => {
  setTimeout(() => {
    applyAutoDiscount();
  }, 1000);

  document.addEventListener('cart:change', () => {
    setTimeout(() => applyAutoDiscount(), 300);
  });

  document.addEventListener('cart:refresh', () => {
    setTimeout(() => applyAutoDiscount(), 300);
  });
});

/* Auto apply discount code  end */


(function initSplitStockFilterState() {
  function parseModeFromSearch(search) {
    const params = new URLSearchParams(search || window.location.search);
    const values = []
      .concat(params.getAll("filter.v.availability"))
      .concat(params.getAll("filter.p.availability"))
      .concat(params.getAll("ro_in_stock_only"));

    if (values.some((value) => String(value).trim() === "1")) {
      return "in";
    }

    if (values.some((value) => String(value).trim() === "0")) {
      return "all";
    }

    return "in";
  }

  function bindAvailabilityToggleInputs(root) {
    const scope = root && root.querySelectorAll ? root : document;

    scope.querySelectorAll("facets-form").forEach((facetsForm) => {
      const hiddenInput = facetsForm.querySelector("input[type=\"hidden\"][name=\"filter.v.availability\"][value=\"0\"]");
      const checkbox = facetsForm.querySelector("input[type=\"checkbox\"][name=\"filter.v.availability\"]");

      if (!hiddenInput || !checkbox || checkbox.dataset.stockSyncBound === "true") {
        return;
      }

      const syncHiddenInput = () => {
        hiddenInput.disabled = checkbox.checked;
      };

      checkbox.addEventListener("change", syncHiddenInput);
      checkbox.dataset.stockSyncBound = "true";
      syncHiddenInput();
    });
  }

  function applySplitStockMode(mode) {
    const inStockOnly = mode !== "all";

    document.querySelectorAll("product-list.product-list-split").forEach((productList) => {
      productList.setAttribute("data-stock-mode", inStockOnly ? "in" : "all");
    });

    document.querySelectorAll("facets-form").forEach((facetsForm) => {
      const hiddenInput = facetsForm.querySelector("input[type=\"hidden\"][name=\"filter.v.availability\"][value=\"0\"]");
      const checkbox = facetsForm.querySelector("input[type=\"checkbox\"][name=\"filter.v.availability\"]");

      if (!hiddenInput || !checkbox) {
        return;
      }

      checkbox.checked = inStockOnly;
      hiddenInput.disabled = inStockOnly;
    });
  }

  function syncSplitStockMode(search) {
    bindAvailabilityToggleInputs(document);
    applySplitStockMode(parseModeFromSearch(search));
  }

  function scheduleSync(search) {
    requestAnimationFrame(() => {
      syncSplitStockMode(search);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => syncSplitStockMode(window.location.search));
  } else {
    syncSplitStockMode(window.location.search);
  }

  document.addEventListener("facet:updated", (event) => {
    const nextSearch = (event && event.detail && event.detail.url && event.detail.url.search) || window.location.search;
    scheduleSync(nextSearch);
  });

  document.addEventListener("shopify:section:load", () => {
    scheduleSync(window.location.search);
  });
})();

(function initAboutTimelineSwipe() {
  const swipeThreshold = 40;
  const wheelCooldownMs = 260;

  function getButtons(timelineEl) {
    return Array.from(timelineEl.querySelectorAll('.timeline__nav button[data-block-id]'));
  }

  function goByStep(timelineEl, step) {
    const buttons = getButtons(timelineEl);
    if (buttons.length < 2) return;

    const currentIndex = buttons.findIndex((button) => button.getAttribute('aria-current') === 'true');
    if (currentIndex < 0) return;

    const nextIndex = Math.max(0, Math.min(buttons.length - 1, currentIndex + step));
    if (nextIndex !== currentIndex) {
      buttons[nextIndex].click();
    }
  }

  function bindTimelineInteractions(timelineEl) {
    if (!timelineEl || timelineEl.dataset.aboutSwipeBound === 'true') return;
    timelineEl.dataset.aboutSwipeBound = 'true';

    let startX = 0;
    let startY = 0;
    let deltaX = 0;
    let deltaY = 0;
    let pointerActive = false;
    let wheelLocked = false;

    const targets = Array.from(
      timelineEl.querySelectorAll('.timeline__content-list, .timeline__image-list, .timeline__content')
    );

    const setDraggingState = (isDragging) => {
      const contentList = timelineEl.querySelector('.timeline__content-list');
      if (!contentList) return;
      contentList.classList.toggle('is-dragging', isDragging);
    };

    const resetGesture = () => {
      pointerActive = false;
      setDraggingState(false);
      startX = 0;
      startY = 0;
      deltaX = 0;
      deltaY = 0;
    };

    const onGestureEnd = () => {
      if (Math.abs(deltaX) < swipeThreshold || Math.abs(deltaX) < Math.abs(deltaY) * 1.15) {
        resetGesture();
        return;
      }

      goByStep(timelineEl, deltaX < 0 ? 1 : -1);
      resetGesture();
    };

    const onTouchStart = (event) => {
      const touch = event.touches && event.touches[0];
      if (!touch) return;

      startX = touch.clientX;
      startY = touch.clientY;
      deltaX = 0;
      deltaY = 0;
    };

    const onTouchMove = (event) => {
      const touch = event.touches && event.touches[0];
      if (!touch) return;

      deltaX = touch.clientX - startX;
      deltaY = touch.clientY - startY;
    };

    const onTouchEnd = (event) => {
      const touch = event.changedTouches && event.changedTouches[0];
      if (touch) {
        deltaX = touch.clientX - startX;
        deltaY = touch.clientY - startY;
      }

      onGestureEnd();
    };

    const onTouchCancel = () => {
      resetGesture();
    };

    const onPointerDown = (event) => {
      if (event.pointerType !== 'mouse') return;
      if (event.button !== 0) return;

      pointerActive = true;
      startX = event.clientX;
      startY = event.clientY;
      deltaX = 0;
      deltaY = 0;
      setDraggingState(true);
    };

    const onPointerMove = (event) => {
      if (!pointerActive) return;

      deltaX = event.clientX - startX;
      deltaY = event.clientY - startY;
    };

    const onPointerUp = () => {
      if (!pointerActive) return;
      onGestureEnd();
    };

    const onWheel = (event) => {
      const absX = Math.abs(event.deltaX);
      const absY = Math.abs(event.deltaY);
      const hasHorizontalIntent = event.shiftKey || absX > absY * 1.2;
      if (!hasHorizontalIntent) return;

      const dominantDelta = absX > 0 ? event.deltaX : event.deltaY;
      if (Math.abs(dominantDelta) < 10) return;

      event.preventDefault();

      if (wheelLocked) return;
      wheelLocked = true;

      goByStep(timelineEl, dominantDelta > 0 ? 1 : -1);

      window.setTimeout(() => {
        wheelLocked = false;
      }, wheelCooldownMs);
    };

    targets.forEach((target) => {
      target.addEventListener('touchstart', onTouchStart, { passive: true });
      target.addEventListener('touchmove', onTouchMove, { passive: true });
      target.addEventListener('touchend', onTouchEnd, { passive: true });
      target.addEventListener('touchcancel', onTouchCancel, { passive: true });

      target.addEventListener('pointerdown', onPointerDown);
      target.addEventListener('pointermove', onPointerMove);
      target.addEventListener('pointerup', onPointerUp);
      target.addEventListener('pointercancel', resetGesture);

      target.addEventListener('wheel', onWheel, { passive: false });
    });
  }

  function init(root) {
    const scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('[id$="__about_timeline"] time-line').forEach(bindTimelineInteractions);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document));
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', (event) => {
    init(event.target || document);
  });
})();

(function initSearchQueryHandoff() {
  const bind = () => {
    const drawer = document.getElementById('search-drawer');
    const drawerInput = document.getElementById('search-drawer-input');

    if (!drawer || !drawerInput || drawer.dataset.queryHandoffReady) return;
    drawer.dataset.queryHandoffReady = 'true';

    let sourceInput = null;

    const resolveSourceInput = (activator) => {
      if (!activator) return null;
      if (activator.matches?.('.header__search-input')) return activator;
      return activator.querySelector?.('.header__search-input') ?? null;
    };

    const syncQuery = () => {
      if (!sourceInput) return;

      drawerInput.value = sourceInput.value;
      drawerInput.dispatchEvent(new Event('input', { bubbles: true }));
    };

    drawer.addEventListener('dialog:before-show', (event) => {
      sourceInput = resolveSourceInput(event.detail?.activator);
      syncQuery();
    });

    document.addEventListener('input', (event) => {
      if (drawer.open && event.target === sourceInput) syncQuery();
    });

    drawer.addEventListener('dialog:after-show', () => {
      if (!sourceInput) return;

      syncQuery();
      drawerInput.focus({ preventScroll: true });
      try {
        const caret = drawerInput.value.length;
        drawerInput.setSelectionRange(caret, caret);
      } catch {
        // type=search can reject setSelectionRange in some browsers
      }
    });

    drawer.addEventListener('dialog:after-hide', () => {
      sourceInput = null;
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind, { once: true });
  } else {
    bind();
  }

  document.addEventListener('shopify:section:load', bind);
})();

(function initBackToTopButton() {
  const button = document.querySelector('.back-to-top');
  if (!button) return;

  const toggleVisibility = () => {
    const show = window.scrollY > 320;
    button.classList.toggle('is-visible', show);
  };

  const onClick = () => {
    try {
      console.info('[plp-is]', 'back-to-top', {
        scrollY: Math.round(window.scrollY || 0),
        cards: document.querySelectorAll('.collection__results .product-card').length
      });
    } catch (error) {
      // Keep the control working even if diagnostics fail.
    }
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  button.addEventListener('click', onClick);
  window.addEventListener('scroll', toggleVisibility, { passive: true });
  window.addEventListener('resize', toggleVisibility, { passive: true });
  toggleVisibility();
})();
